import $ from "jquery";

class Favorites {

    constructor() {
        this.init();
    }

    init() {
        const apiPath = $('.js-favorites').data('api-url');
        $('.js-favorite-delete-js').each((i, el) => {
            const $holder = $(el).parent();
            $(el).click((e) => {
                e.preventDefault();
                e.stopPropagation();
                $.get({
                    url: apiPath,
                    data: { 'apartmentId': $(el).data('id') },
                    success: (fResponse) => {
                        $holder.remove();
                        $('.sidebar-favorites__count').text(fResponse.count);
                        if ($('.js-favorite-delete-js').length === 0) {
                            $('.js-favorites').hide();
                            $('.js-favorites-empty').show();
                        }
                    }
                })
            });
        })
    }
}

export default new Favorites();



// WEBPACK FOOTER //
// ./js/favorites.js